<template>
    <component
        :is="bannerComponent"
        :entry="banner"
    />
</template>

<script setup>
    const pageType = inject('page-type', 'home')

    const { digistormSettings, entry } = storeToRefs(useSiteStore())

    const banner = ref(null)
    const query = ref()

    // check for any custom headers
    // TODO: get the school code from the somewhere
    const code = 'school-code'

    const bannerType = computed(() => {
        // return 'custom'
        return digistormSettings.value.bannerType
    })

    const customComponents = await import(`~/node_modules/@digistorm/web-frontend-components/dist/${code}.js`)
        .catch(() => {
            console.log('no custom components')
        })

    if (customComponents?.default && bannerType.value === 'custom') {
        if (pageType === 'home') {
            query.value = customComponents?.default?.HomeBannerQuery
        } else {
            query.value = customComponents?.default?.PageBanner
        }
    } else if (pageType === 'home') {
        // check the bannerType and dynamically import the query from queries/banners/{bannerType}.ts
        query.value  = await import(`~/queries/banners/${bannerType.value}.ts`).then((q) => {
            return `
                ... on ${entry.value.__typename} {
                    ${q.default}
                }
            `
        })
            .catch(async () => {
                // fall back to the old bannerQuery for now
                return (await import('~/queries/banners/HomeBanner.ts')).default
            })

    }

    const getBannerData = async () => {
        if (!query.value) {
            return []
        }

        const bannerQuery = `
query pageContent($canonicalUid: String) {
    entry(uid: [$canonicalUid]) {
        ${query.value}
    }
}`

        const { data, error } = await useAsyncQuery({
            query: gql`${bannerQuery}`,
            variables: {
                canonicalUid: entry.value?.canonicalUid
            },
            cache: false,
        })

        if (!isEmpty(error.value)) {
            console.log('custom query failed', error.value)
        }

        banner.value = get(data.value, 'entry', [])
    }

    const bannerComponent = computed(() => {
        if (bannerType.value === 'custom') {
            if (pageType === 'home') {
                return customComponents?.default?.HomeBanner
            }
            return customComponents?.default?.PageBanner
        }

        return defineAsyncComponent(() =>
            import(`./${pageType}/${bannerType.value}/banner.async.vue`)
        )
    })

    await getBannerData()

</script>

<style lang="scss" scoped>

</style>